import {
    ACCOUNT_TYPE_ENUM,
    CLIENT_ACCOUNT_STATUS_ENUM,
    IBusinessAccountDetailsDto,
    IContactAccountDto,
    ISkinnyBusinessAccountContactDto
} from '@classictechsolutions/hubapi-transpiled-enums';
import { Component, Input, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { ContactsLogicService } from '@app/logic/contacts/contacts-logic.service';
import { IBusinessAccountContactDto } from '@app/logic/business-accounts';
import { MatDialog } from '@angular/material/dialog';
import { NavigationService } from '@app/core/services/navigation/navigation.service';
import { PermissionsPermissions } from '@app/core/permissions';
import { switchMap } from 'rxjs';
import { toPromise } from 'cb-hub-lib';
import { IContactDto } from '@app/logic/contacts/interfaces/i.contact.dto';

@Component({
    selector: 'cb-account-list',
    templateUrl: './account-list.component.html',
    styleUrls: ['./account-list.component.scss'],
    providers: [ContactsLogicService],
    standalone: false
})
export class AccountListComponent implements OnInit {

    @Input() public contactId: string;

    public CLIENT_ACCOUNT_STATUS_ENUM = CLIENT_ACCOUNT_STATUS_ENUM;
    public ACCOUNT_TYPE_ENUM = ACCOUNT_TYPE_ENUM;

    public readonly clientAccountColumns: string[] = [
        'abmCode',
        'status',
        'name',
        'type',
        'lots',
        'address',
        'city',
        'region',
        'actions'
    ];

    public readonly businessAccountColumns: string[] = [
        'abmCode',
        'tradingName',
        'legalName',
        'type',
        'status',
        'actions'
    ];

    public businessAccounts: ISkinnyBusinessAccountContactDto[];
    public clientAccounts: IContactAccountDto[];

    public businessAccountsLoaded = false;
    public clientAccountsLoaded = false;

    constructor(
        public readonly navigationService: NavigationService,
        public readonly dialogRef: MatDialog,
        protected readonly contactsLogicService: ContactsLogicService,
        public readonly permissionsPermissions: PermissionsPermissions,
        public readonly route: ActivatedRoute,
    ) { }

    public ngOnInit(): void {

        toPromise(this.route.params.pipe(
            switchMap((params: { id: string }) => {
                return this.contactsLogicService.getBusinessAccountsList(params.id);
            })
        )).then((dtos: ISkinnyBusinessAccountContactDto[]) => {
            this.businessAccounts = dtos;
            this.businessAccountsLoaded = true;
        });

        toPromise(this.route.params.pipe(
            switchMap((params: { id: string }) => {
                return this.contactsLogicService.getClientAccountsList(params.id);
            })
        )).then((dtos: IContactAccountDto[]) => {
            this.clientAccounts = dtos;
            this.clientAccountsLoaded = true;
        });

    }

    public sortSearchResults(searchResults: Array<IContactDto>): Array<IContactDto> {
        return searchResults.sort((a, b) => a.guid.localeCompare(b.guid));
    }

    public viewClientAccount(account: IBusinessAccountDetailsDto, event: MouseEvent): void {
        this.navigationService.navigate([`accounts/${account.id}/summary`], event);
    }

    public viewBusinessAccount(account: IBusinessAccountContactDto, event: MouseEvent): void {
        this.navigationService.navigate([`/business-accounts/edit/${account.id}/details`], event);
    }
}
